import { OrderError, OrderStatus } from "@deliverr/business-types";

export const isBadAddress = (order) => order.error === OrderError.BAD_ADDRESS && order.status === OrderStatus.ERROR;
